__turbopack_context__.v({
  "blink": "Content-module-scss-module__9TV3zG__blink",
  "borderTop": "Content-module-scss-module__9TV3zG__borderTop",
  "collapsed": "Content-module-scss-module__9TV3zG__collapsed",
  "credits": "Content-module-scss-module__9TV3zG__credits",
  "creditsMobile": "Content-module-scss-module__9TV3zG__creditsMobile",
  "expanded": "Content-module-scss-module__9TV3zG__expanded",
  "footnotes": "Content-module-scss-module__9TV3zG__footnotes",
  "gallery": "Content-module-scss-module__9TV3zG__gallery",
  "galleryOpen": "Content-module-scss-module__9TV3zG__galleryOpen",
  "image": "Content-module-scss-module__9TV3zG__image",
  "noFootnotes": "Content-module-scss-module__9TV3zG__noFootnotes",
  "overviewButton": "Content-module-scss-module__9TV3zG__overviewButton",
  "readMoreButton": "Content-module-scss-module__9TV3zG__readMoreButton",
  "sideText": "Content-module-scss-module__9TV3zG__sideText",
  "text": "Content-module-scss-module__9TV3zG__text",
});
